

const target = document.querySelector('.datos-image-banner');

const isVisible = () => {
  const windowHeight = window.innerHeight;
   const currentTragetOffsetY = target.offsetTop - window.pageYOffset;
   if (currentTragetOffsetY <= windowHeight) {
    const currentNum = document.querySelector(".percentage .number").innerHTML;   
    if(currentNum == "0") {
      increase();
    }
   } else {
   }
      
};
window.addEventListener('scroll', isVisible);
window.addEventListener('resize', isVisible);

function increase() {
  let elem = document.querySelector(".percentage .number");   
  let currentNum = 0;
  let targetNum = elem.dataset.value;
  let id = setInterval(frame, 10);
  function frame() {
    if (currentNum >= targetNum) {
      clearInterval(id);
    } else {
      currentNum++; 
      elem.innerHTML = currentNum; 
    }
  }
}

document.addEventListener("DOMContentLoaded", isVisible);